import { createContext } from "react";

export const LookupValueContext = createContext({});
